import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "schedule-list"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Сегодня нерабочий день", -1)
const _hoisted_4 = [
  _hoisted_3
]

import timerIcon from '@/assets/icons/emojis/time.png';
import schoolIcon from '@/assets/icons/emojis/school.png';
import studentIcon from '@/assets/icons/emojis/student.png';
import bellIcon from '@/assets/icons/emojis/bell.png';
import teacherIcon from '@/assets/icons/emojis/teacher.png';
import { onMounted, reactive } from 'vue';
import { getStudentModifiedScheduleSubpage } from './apiMethods';
import { GetStudentModifiedScheduleSubpageResponseModel } from './ModifiedSchedulePage.types';
import universalCard from '@/common/components/snedson-material-components/universal-card/universal-card.vue';
import { getBaseUrl } from '@/http/api/';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModifiedScheduleSubpage',
  setup(__props) {

const state = reactive<{
    data: GetStudentModifiedScheduleSubpageResponseModel | null;
}>({ data: null });

onMounted(() => {
    getStudentModifiedScheduleSubpage().then((res) => {
        state.data = res.data;
        console.log(res);
    });
});

return (_ctx: any,_cache: any) => {
  return (state.data && state.data.msesForToday.mseList)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.data.msesForToday.mseList, (mse) => {
          return (_openBlock(), _createBlock(universalCard, {
            props: {
                content:  mse.comments as string | undefined,
                type: 'elevated-secondary',
                title: `${mse.num}. ${mse.subjectFullName}`,
                icon: _unref(getBaseUrl)() + mse.iconURL,
                dataTags: [
                    {
                        iconCompleteUrl: _unref(timerIcon),
                        color: 'var(--snotra--sys--surface)', 
                        title: `${state.data.mspsForToday.todayScheduleParams[mse.num-1].begin} - ${state.data.mspsForToday.todayScheduleParams[mse.num-1].end} (${state.data.mspsForToday.todayScheduleParams[mse.num-1].durationInMins} мин.)`,
                    },
                    {
                        iconCompleteUrl: _unref(schoolIcon),
                        color: 'var(--snotra--sys--surface)', 
                        title: mse.location,
                    },
                    {
                        iconCompleteUrl: _unref(studentIcon),
                        color: 'var(--snotra--sys--surface)',
                        title: mse.groupName ? mse.groupName : 'Весь класс ',
                    },
                    {
                        iconCompleteUrl: _unref(bellIcon),
                        color: 'var(--snotra--sys--surface)',
                        title: `Перемена после: ${state.data.mspsForToday.todayScheduleParams[mse.num-1].breakDurationInMins} мин.`,
                    },
                    {
                        iconCompleteUrl: _unref(teacherIcon), 
                        color: 'var(--snotra--sys--surface)', 
                        title: mse.hostName,
                    },
                ], 
            },
            key: mse.num,
            class: _normalizeClass(mse.colorSchemeName)
          }, null, 8, ["props", "class"]))
        }), 128))
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
}
}

})